export default __webpack_public_path__ + "static/media/map-view.f6fb69d4.svg";